import BaseSetup from '@/components/BaseSetup';

export type SharedStateIconEmits = {};

export type SharedStateIconProps = {
	small?: boolean
	clickable?: boolean
	state?: StateIcon
};

export default class SharedStateIconSetup extends BaseSetup {

	static readonly defaultProps = { state: 'complete' as StateIcon };

	constructor (
		private props: SharedStateIconProps,
		private emits: SharedStateIconEmits,
	) {
		super();
	}

}
